module.exports = __webpack_public_path__ + "img/poster-2.a4fa2142.jpg";